import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Message } from "src/app/core/class/message";
import { AutoEnterpriseService } from "src/app/core/services/auto-enterprise.service";
import { CommonService } from "src/app/core/services/common.service";
import { CustomerService } from "src/app/core/services/customer.service";

@Component({
    selector: 'app-share-partner-picker',
    templateUrl: './share-partner-picker.component.html',
    styleUrls: ['./share-partner-picker.component.scss']
})
export class SharePartnerPickerComponent implements OnInit {
    @Input() selectedPartners: any[] = [];
    @Output() selectedPartnersChange = new EventEmitter<any[]>();

    byCustomer = true;
    byGroup = false;

    filteredPartyOptions: any = []
    timeOutQueryServer: any;
    inputPartyValue: string = ''
    nzCheckLoadingParty2 = false

    inputGroupValue: string = ''
    timeOutQueryGroup: any;
    nzCheckLoadingGroup = false
    filteredGroupOptions: any = []

    constructor(
        private message: Message,
        private toastr: ToastrService,
        public commonService: CommonService,
        public autoEnterpriseService: AutoEnterpriseService,
        private customerService: CustomerService,
    ) {
    }

    ngOnInit() {
        if (!this.selectedPartners || this.selectedPartners.length === 0) {
            this.selectedPartners = [];
        }
        this.byCustomer = true;
        this.byGroup = false;
    }

    get selectedCustomers() {
        return (this.selectedPartners || []).filter(p => !p.isGroup);
    }

    get selectedGroups() {
        return (this.selectedPartners || []).filter(p => p.isGroup);
    }

    emitChange() {
        this.selectedPartnersChange.emit(this.selectedPartners);
    }

    setPermission(item: any, permission: string) {
        item.permission = permission;
        this.selectedPartners = [...this.selectedPartners];
        this.emitChange();
    }

    onChangePartySignSearch($event: any): void {
        this.filteredPartyOptions = [];
        if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
            if (this.timeOutQueryServer) {
                clearTimeout(this.timeOutQueryServer);
            }
            this.timeOutQueryServer = setTimeout(() => {
                if (this.inputPartyValue.trim().length > 0) {
                    this.nzCheckLoadingParty2 = true;
                    this.autoEnterpriseService.fetchAuto(this.inputPartyValue.trim())
                        .then(result => {
                            this.filteredPartyOptions = [];
                            if (result) {
                                for (const item of result) {
                                    if (!item.isCreatedSide) {
                                        if (!this.checkExistedParty(item.enterpriseId, item.customerId)) {
                                            const existedList = this.filteredPartyOptions.filter((e) => {
                                                return e.enterpriseId === item.enterpriseId;
                                            });
                                            this.filteredPartyOptions.push(item);
                                        }
                                    }
                                }
                            }
                        }).finally(() => {
                            this.nzCheckLoadingParty2 = false;
                        });
                } else {
                    this.inputPartyValue = '';
                }
            }, 500);

        }
    }
    autocompletePartySelected($event: any, model: any) {
        if ($event.isUserInput) {
            if (!this.checkExistedParty(model.enterpriseId, model.customerId)) {
                this.selectedPartners = [
                    ...this.selectedPartners,
                    {
                        enterpriseId: model.enterpriseId,
                        customerId: model.customerId,
                        email: model.email,
                        name: model.name,
                        phone: model.phone,
                        permission: 'FILE',
                        isGroup: false
                    }
                ];
                this.emitChange();

                this.inputPartyValue = '';
                this.filteredPartyOptions = [];

            } else {
                this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_party_apostrophe_duplicate'), model.name));
            }
        }
    }
    checkExistedParty(enterpriseId: string, customerId: string) {
        const existedList = this.selectedCustomers.filter((e) => {
            return enterpriseId ? e.enterpriseId === enterpriseId : e.customerId === customerId;
        });

        return (existedList.length > 0);
    }
    onClickDeleteElementRecordParty(enterpriseId: any, customerId: any): void {
        if (enterpriseId && enterpriseId.length > 0) {
            this.selectedPartners = this.selectedPartners.filter(d => d.enterpriseId !== enterpriseId || d.isGroup);
        } else {
            this.selectedPartners = this.selectedPartners.filter(d => d.customerId !== customerId || d.isGroup);
        }
        this.emitChange();
    }

    onChangeGroupSearch($event: any): void {
        // một số input event không có inputType (autofill/IME) - vẫn phải gọi search
        if (!$event.inputType || $event.inputType.includes('insert') || $event.inputType.includes('delete')) {
            if (this.timeOutQueryGroup) {
                clearTimeout(this.timeOutQueryGroup);
            }
            this.timeOutQueryGroup = setTimeout(() => {
                if (this.inputGroupValue.trim().length > 0) {
                    this.searchCustomerGroups(this.inputGroupValue.trim());
                } else {
                    this.inputGroupValue = '';
                }
            }, 500);
        }
    }

    // tick bật tab nhóm => load sẵn danh sách nhóm (không cần chờ user gõ)
    onToggleByGroup(checked: boolean): void {
        if (checked && this.filteredGroupOptions.length === 0) {
            this.searchCustomerGroups('');
        }
    }

    // load sẵn danh sách nhóm khi mở tab (giống luồng quản lý nhóm) - keyword rỗng = lấy tất cả
    searchCustomerGroups(keyword: string): void {        this.nzCheckLoadingGroup = true;
        this.customerService.filterCustomerGroups({
            page: 0,
            pageSize: 50,
            keyword: keyword,
            skipCustomerIds: true
        }).subscribe(rs => {
            this.filteredGroupOptions = rs && rs.data && rs.data.content ? rs.data.content : [];
            this.filteredGroupOptions = this.filteredGroupOptions.filter(g => !this.checkExistedGroup(g.id));
            this.nzCheckLoadingGroup = false;
        }, () => {
            this.nzCheckLoadingGroup = false;
        });
    }

    autocompleteGroupSelected($event: any, model: any) {
        if ($event.isUserInput) {
            if (!this.checkExistedGroup(model.id)) {
                this.selectedPartners = [
                    ...this.selectedPartners,
                    {
                        groupId: model.id,
                        name: model.name,
                        permission: 'FILE',
                        isGroup: true
                    }
                ];
                this.emitChange();

                this.inputGroupValue = '';
                this.filteredGroupOptions = [];
            } else {
                this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_party_apostrophe_duplicate'), model.name));
            }
        }
    }

    checkExistedGroup(groupId: string) {
        return this.selectedGroups.filter(g => g.groupId === groupId).length > 0;
    }

    onClickDeleteElementRecordGroup(groupId: any): void {
        this.selectedPartners = this.selectedPartners.filter(g => g.groupId !== groupId);
        this.emitChange();
    }
}
